import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("CRITICAL_PATH");
const CRUD_ACTION_HANDLERS = getActionHandler("CRITICAL_PATH");

export default function criticalpaths(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
